exports = module.exports = require("../../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"xs": "0",
	"sm": "544px",
	"md": "768px",
	"lg": "992px",
	"xl": "1200px",
	"xxl": "1480px"
};